import { RepoUrlPickerState } from './interfaces';
import { ProjectItem } from '@internal/plugin-alm-services';

export function UpdateState(
  data: RepoUrlPickerState,
  projectItems: ProjectItem[],
) {
  if (!data.host) {
    return data;
  }
  const params = new URLSearchParams();
  if (data.project) {
    params.set('project', data.project);
  }
  if (data.repoName) {
    params.set('repo', `${data.repositoryType}-${data.repoName}`);
  }
  if (data.organization) {
    params.set('organization', data.organization);
  }

  data.url = `${data.host}?${params.toString()}`;

  if (data.project && projectItems) {
    data.projectId = projectItems.find(e => e.name == data.project)?.id;
  }
  return data;
}

export function createState(data: any): RepoUrlPickerState {
  const host = data?.host ?? 'dev.azure.com';
  const repositoryType = data?.repositoryType ?? '';
  const repoName = data?.repoName ?? '';
  const organization = data?.organization ?? 'itglo';
  const project = data?.project ?? '';
  const projectId = data?.projectId ?? '';

  const state: RepoUrlPickerState = {
    host,
    repositoryType,
    repoName,
    organization,
    project,
    projectId,
  };

  return state;
}
